import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../components/ThumbnailRightPanel.module.css';

export interface Resolution {
  label: string;
  translationKey: string;
  width: number;
  height: number;
  aspectRatio: string;
}

interface ResolutionSelectorProps {
  currentResolution: Resolution;
  onResolutionChange: (resolution: Resolution) => void;
}

const commonResolutions: Resolution[] = [
  { label: 'YouTube Thumbnail (16:9)', translationKey: 'youtubeThumbnail', width: 1280, height: 720, aspectRatio: '16:9' },
  { label: 'HD Wide (16:9)', translationKey: 'hdWide', width: 1920, height: 1080, aspectRatio: '16:9' },
  { label: 'Instagram Post (1:1)', translationKey: 'instagramPost', width: 1080, height: 1080, aspectRatio: '1:1' },
  { label: 'Twitter Header (3:1)', translationKey: 'twitterHeader', width: 1500, height: 500, aspectRatio: '3:1' },
  { label: 'Facebook Cover (16:9)', translationKey: 'facebookCover', width: 1640, height: 924, aspectRatio: '16:9' },
  { label: 'Standard (4:3)', translationKey: 'standard', width: 1024, height: 768, aspectRatio: '4:3' },
  { label: 'Portrait (9:16)', translationKey: 'portrait', width: 720, height: 1280, aspectRatio: '9:16' },
];

const ResolutionSelector: React.FC<ResolutionSelectorProps> = ({
  currentResolution,
  onResolutionChange
}) => {
  const { t } = useTranslation('thumbnailEditor');
  
  const handleResolutionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedResolution = commonResolutions.find(res => res.label === e.target.value);
    if (selectedResolution) {
      onResolutionChange(selectedResolution);
    }
  };

  return (
    <div className={styles.control} style={{ marginBottom: '1rem' }}>
      <label>{t('thumbnailEditor.outputResolution')}</label>
      <select
        value={currentResolution.label}
        onChange={handleResolutionChange}
        className={styles.selectInput}
      >
        {commonResolutions.map(res => (
          <option key={res.label} value={res.label}>
            {t(`thumbnailEditor.resolutionLabels.${res.translationKey}`)}
          </option>
        ))}
      </select>
      <div style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
        {currentResolution.width} × {currentResolution.height} ({currentResolution.aspectRatio})
      </div>
    </div>
  );
};

export default ResolutionSelector;
export { commonResolutions };